import { useEffect, useState } from "react";
import axios from "axios";
import { API } from "../context/AuthContext";
import { toast } from "sonner";
import { FileText, Lock, Save } from "lucide-react";

const inp = "w-full bg-black/40 border border-white/10 rounded-md px-3 py-2 text-sm outline-none focus:border-[#FF1E27]";

export default function RallyInfoPanel({ rallyId, onSaved }) {
  const [f, setF] = useState(null);
  useEffect(() => { axios.get(`${API}/organizer/rallies/${rallyId}/info`).then(r => setF(r.data)).catch(() => {}); }, [rallyId]);
  if (!f) return null;
  const save = async () => {
    try { const { data } = await axios.put(`${API}/organizer/rallies/${rallyId}/info`, f); setF(data); toast.success("Pagina rally aggiornata"); onSaved?.(); }
    catch (e) { toast.error(e.response?.data?.detail || "Errore"); }
  };
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });
  return (
    <div className="rl-card p-6 lg:col-span-2" data-testid="rally-info-panel">
      <h2 className="font-display font-bold text-xl flex items-center gap-2 mb-1"><FileText className="w-5 h-5 text-[#FF9F0A]" /> Pagina rally: programma, mappa, info</h2>
      <p className="text-xs text-slate-500 mb-4">Visibile ai fan nel tab INFO del Paddock. Formattazione: righe vuote per i paragrafi, "## Titolo" per le sezioni, "- " per le liste.</p>
      {!f.allowed && <div className="text-sm text-slate-400 flex items-center gap-2"><Lock className="w-4 h-4" /> Attiva una licenza PRO per scrivere la pagina del rally.</div>}
      {f.allowed && (
        <div className="grid md:grid-cols-2 gap-4">
          <div>
            <div className="text-[10px] font-mono-rl text-slate-500 tracking-widest mb-1">PROGRAMMA</div>
            <textarea className={`${inp} min-h-[180px]`} value={f.program} onChange={set("program")} placeholder={"## Venerdì\n- 09:00 Verifiche\n- 18:00 Shakedown\n\n## Sabato\n- 08:01 PS1 ..."} data-testid="rally-info-program" />
          </div>
          <div>
            <div className="text-[10px] font-mono-rl text-slate-500 tracking-widest mb-1">INFO LOGISTICHE</div>
            <textarea className={`${inp} min-h-[180px]`} value={f.logistics} onChange={set("logistics")} placeholder={"Parco assistenza, parcheggi fan, punti spettatore, ristoro, hotel convenzionati..."} data-testid="rally-info-logistics" />
          </div>
          <div>
            <div className="text-[10px] font-mono-rl text-slate-500 tracking-widest mb-1">MAPPA (link Google Maps / embed)</div>
            <input className={inp} value={f.map_url} onChange={set("map_url")} placeholder="https://www.google.com/maps/d/embed?mid=..." data-testid="rally-info-map" />
          </div>
          <div>
            <div className="text-[10px] font-mono-rl text-slate-500 tracking-widest mb-1">SITO UFFICIALE</div>
            <input className={inp} value={f.website} onChange={set("website")} placeholder="https://www.tuorally.it" data-testid="rally-info-website" />
          </div>
          <div className="md:col-span-2"><button className="btn-crimson !py-2 !px-4 text-xs" onClick={save} data-testid="rally-info-save"><Save className="w-4 h-4 inline mr-1" />SALVA PAGINA RALLY</button></div>
        </div>
      )}
    </div>
  );
}
